export default {
    title: 'New features in the Trendmanager',
    content: 'We have added new features and functions to the Trendmanager. Visit our <strong>Product update</strong> section to read more.',
    action: {
        ok: 'Show product updates',
        close: 'Cancel',
        doNotShowAgain: 'Don\'t show again'
    }
}
